import { compose, path } from 'ramda';
import { withRouter } from 'react-router-dom';

import DoctorPatientPageContent from 'components/DoctorPatientPage/Content';
import withPageLoader from 'components/withPageLoader';

import { requestQuestionnaireResponse } from 'store/actionCreators/questionnaireResponses';
import { getPatientPageUrlParams } from 'store/selectors/router';
import { getQuestionnaireResponseShouldShowLoading } from 'store/selectors/questionnaireResponses';

export default compose(
  withRouter,
  withPageLoader({
    loadingSelector: (state, ownProps) => {
      const patientId = path(['match', 'params', 'id'], ownProps);
      return getQuestionnaireResponseShouldShowLoading(patientId)(state);
    },
    initialAction: requestQuestionnaireResponse,
    initialActionArgsSelector: getPatientPageUrlParams,
  }),
)(DoctorPatientPageContent);
